import { apiClient } from './apiClient';
import { LoanPayment, CreateLoanPaymentRequest, UpdateLoanPaymentRequest } from './types';

const BASE_URL = '/v1/loans';

export const loanPaymentService = {
  getByLoanId: async (loanId: string): Promise<LoanPayment[]> => {
    const response = await apiClient.get<LoanPayment[]>(`${BASE_URL}/${loanId}/payments`);
    return response;
  },

  getById: async (id: string): Promise<LoanPayment> => {
    const response = await apiClient.get<LoanPayment>(`${BASE_URL}/payments/${id}`);
    return response;
  },

  create: async (request: CreateLoanPaymentRequest): Promise<LoanPayment> => {
    const response = await apiClient.post<CreateLoanPaymentRequest, LoanPayment>(`${BASE_URL}/payments`, request);
    return response;
  },

  update: async (id: string, request: UpdateLoanPaymentRequest): Promise<LoanPayment> => {
    const response = await apiClient.put<UpdateLoanPaymentRequest, LoanPayment>(`${BASE_URL}/payments/${id}`, request);
    return response;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/payments/${id}`);
  }
};

